export const NAMESPACE = 'KanBo/observedTags/'
export const ADD = NAMESPACE + 'ADD'
export const SET = NAMESPACE + 'SET'
export const REMOVE = NAMESPACE + 'REMOVE'

const initialState = []

export default function reducer (state: any = initialState, action: any = {}) {
  switch (action.type) {
    case ADD:
      return !state.includes(action.payload.tag) ? [
        ...state,
        action.payload.tag,
      ] : state
    case SET:
      return [
        ...action.payload.tags
      ]
    case REMOVE:
      return state.includes(action.payload.tag)
      ? state.filter(tag => tag !== action.payload.tag)
      : state
    default: return state
  }
}

export function add ({ tag }) {
  return {
    type: ADD,
    payload: {
      tag,
    }
  }
}

export function set ({ tags }) {
  return {
    type: SET,
    payload: {
      tags,
    }
  }
}

export function remove ({ tag }) {
  return {
    type: REMOVE,
    payload: {
      tag,
    }
  }
}